import React, { useEffect } from "react";
import ProductModal from "src/features/product-modal/ProductModal";
import Responsive from "src/shared/components/Responsive";
import http from "src/shared/http";
import projectOptions from "src/shared/project-options";
import CombinedProductModal from "../combined-product/components/CombinedProductModal";
import "./Home.scss";

const MainContainer = () => {
  const { eventId, baseUrl } = projectOptions.default.network;

  useEffect(() => {
    // increase view count by one
    http(baseUrl + "/public/events/" + eventId + "/hit-count/", {
      method: "post",
    });
  }, [baseUrl, eventId]);

  return (
    <div>
      <Responsive
        desktop={() => import("./components/Desktop")}
        mobile={() => import("./components/Mobile")}
      >
        {(Component: any) => <Component />}
      </Responsive>

      <ProductModal />
      <CombinedProductModal />
    </div>
  );
};

export default MainContainer;
